import React, { Component } from 'react'
import { connect } from 'react-redux'

import SelectBox from './common/selectbox/selectBox'
import CalendarSvg from '../assets/calendar.svg'
import ListSvg from '../assets/list.svg'
import ListSelectedSvg from '../assets/list_selected.svg'
import GridSvg from '../assets/grid.svg'
import GridSelectedSvg from '../assets/grid_selected.svg'
import { threatIntelInitialState } from '../store/initialState/threatintelState'
import './ThreatIntelFilter.scss'
import SearchBox from './common/searchBox/searchBox'

class ThreatIntelFilter extends Component {
  state = {
    customerChanged: false,
    threatFilters: this.props.threatFilters,
    removeRepeatURL : this.props.parseRemoveRepeat ? this.props.parseRemoveRepeat() : false,
  }

  rangeOptions = [
    { name: 'Last 30 days', value: 'last30d', id: "0" },
    { name: 'Last 60 days', value: 'last60d', id: "1" },
    { name: 'Last 90 days', value: 'last90d', id: "2" },
    { name: 'Last 1 year', value: 'last1y', id: "3" },
    { name: 'Last 3 years', value: 'last3y', id: "4" },
  ]

  componentDidMount() {
    this.initializeFilters();
  }

  componentDidUpdate(prevProps) {
    const { parseRemoveRepeat } = this.props
    if(prevProps.filters !== this.props.filters) {
      this.setState({
        removeRepeatURL: parseRemoveRepeat ? parseRemoveRepeat() : false,
      })
    }
  }

  initializeFilters = () => {
    this.setState({
      threatFilters: threatIntelInitialState.filters,
    })
  }

  render() {
    const { viewType, handleViewSelect, handleSearch, handleSelect, handleRemoveRepeatURL, parseSearchBrand, parseRemoveRepeat } = this.props
    return (
      <div className="Mask">
        <div className="filterBar">
          <div className="d-flex" style={{ width: '20%', padding: '5px' }}>
            <SearchBox
              style={{ width: '20%' }}
              placeholder="Search Brand"
              value={parseSearchBrand ? parseSearchBrand() : ''}
              handleSearch={handleSearch}
            />
          </div>
          <div className="separator"></div>
          <SelectBox
            role="PixmAdmin,TenantAdmin,CustomerAdmin"
            width="220px"
            optionBoxWidth="220px"
            selectedOption={null}
            options={this.rangeOptions}
            defaultOption={this.rangeOptions[0]}
            customerChanged={false}
            onSelect={handleSelect}
            icon={CalendarSvg}
            type="range"
          />
          <div className="separator"></div>
          <div
            style={{
              width: '15%',
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '10px',
              gap: '8px'
            }}
          >
            <input
              type="checkbox"
              id="rmRepeatURL"
              name="rmRepeatURL"
              onChange={(e) => {
                this.setState({ removeRepeatURL: e.target.checked })
                handleRemoveRepeatURL(e)
              }}
              style={{
                verticalAlign: 'middle',
                margin: 0
              }}
              checked={this.state.removeRepeatURL}
            />
            <label htmlFor="rmRepeatURL" style={{ margin: 0 }}>
              Remove Repeated URLs
            </label>
          </div>
          <div className="separator"></div>
          <div className="viewName">
            {/* <span>{viewType === 'grid' ? 'Grid View' : 'List View'}</span> */}
          </div>
          <div className="rightSection">
            <div className="separator"></div>
            <div className="viewIcons">
              <div title="List view">
                <img
                  src={!viewType || viewType === 'list' ? ListSelectedSvg : ListSvg}
                  style={{ height: '25px' }}
                  alt=""
                  onClick={() => handleViewSelect('list')}
                />
              </div>
            </div>
            <div className="separator"></div>
            <div className="viewIcons">
              <div title="Grid view">
                <img
                  src={viewType === 'grid' ? GridSelectedSvg : GridSvg}
                  style={{ height: '25px' }}
                  alt=""
                  onClick={() => handleViewSelect('grid')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(ThreatIntelFilter)